export enum sortDirection {
  "Ascending" = "asc",
  "Descending" = "desc",
}
